export const DATADOG_PRIVACY_LEVELS = Object.freeze({
  ALLOW: 'allow',
  MASK: 'mask',
  HIDDEN: 'hidden',
  MASK_USER_INPUT: 'mask-user-input',
});
